import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getMessagesPerTeam = ({ churchId }) => {
  return axios.get(`/churches/${churchId}/dashboard/team-messages`);
};

export const useMessagesPerTeam = ({ churchId, config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["team-messages", churchId],
    queryFn: () => getMessagesPerTeam({ churchId }),
    select: response => response.result,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
    staleTime: 0,
    cacheTime: 0
  });
};
